import { TypedMatNode } from "../_Base";
import { BaseTextureMapController, BooleanParamOptions, NodePathOptions } from "./_BaseTextureController";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
export function MapParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.useMap = ParamConfig.BOOLEAN(0, BooleanParamOptions(TextureMapController));
      this.map = ParamConfig.NODE_PATH("", NodePathOptions(TextureMapController, "useMap"));
    }
  };
}
class TextureMapParamsConfig extends MapParamConfig(NodeParamsConfig) {
}
class TextureMapMatNode extends TypedMatNode {
}
export class TextureMapController extends BaseTextureMapController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  initializeNode() {
    this.add_hooks(this.node.p.useMap, this.node.p.map);
  }
  async update() {
    this._update(this.node.material, "map", this.node.p.useMap, this.node.p.map);
  }
  static async update(node) {
    node.controllers.map.update();
  }
}
